module.exports = __webpack_public_path__ + "static/media/search-join.89441850.svg";